import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    // 初期状態で最初のタブを表示
    this.showTab(this.tabTargets[0])
  }

  switch(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    this.showTab(clickedTab)
  }

  showTab(tab) {
    const tabName = tab.dataset.tabName

    // 全てのタブを非アクティブにする
    this.tabTargets.forEach(t => t.classList.remove("active"))

    // 全てのコンテンツを非表示にする
    this.contentTargets.forEach(c => c.style.display = "none")

    // クリックされたタブをアクティブにする
    tab.classList.add("active")

    // 対応するコンテンツを表示する
    const content = this.contentTargets.find(c => c.dataset.tabName === tabName)
    if (content) {
      content.style.display = "block"
    }
  }
}
